import templateUrl from 'webutils/media/media-manager-prompt.htm'
import controller from 'webutils/media/media-manager-prompt.controller'
import modals from 'webmodals/modals'

export default (options) => modals.open({
        size: options.size || 'md',
        templateUrl: options.templateUrl || templateUrl,
        controller,
        bindToController: true,
        controllerAs: '$ctrl',
        resolve: {
            options: () => options
        }
    }).result;